var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 108,
    viewBox: "0 0 90 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 107,
    rx: 2.5,
    stroke: "#728095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2631 19.1772C50.5912 18.8492 51.0362 18.665 51.5001 18.665C51.964 18.665 52.4089 18.8492 52.7371 19.1772L55.3231 21.7632C55.651 22.0913 55.8352 22.5363 55.8352 23.0002C55.8352 23.4641 55.651 23.909 55.3231 24.2372L52.5301 27.0302L52.5181 27.0432L41.6901 37.3782C41.4923 37.5673 41.2529 37.7074 40.9911 37.7872L35.4681 39.4672C35.3382 39.5065 35.2001 39.5098 35.0684 39.4767C34.9368 39.4437 34.8166 39.3756 34.7206 39.2796C34.6247 39.1836 34.5566 39.0634 34.5235 38.9318C34.4905 38.8002 34.4938 38.6621 34.5331 38.5322L36.2061 33.0322C36.2938 32.7443 36.4543 32.4839 36.6721 32.2762L47.4761 21.9632L50.2631 19.1772ZM47.9881 23.5482L37.7081 33.3612C37.6768 33.3908 37.6537 33.428 37.6411 33.4692L36.3771 37.6232L40.5541 36.3522C40.5916 36.3406 40.6258 36.3204 40.6541 36.2932L50.9271 26.4872L47.9871 23.5482H47.9881ZM52.0001 25.4402L54.2631 23.1782C54.2864 23.1549 54.3048 23.1274 54.3174 23.097C54.33 23.0666 54.3365 23.034 54.3365 23.0012C54.3365 22.9683 54.33 22.9357 54.3174 22.9053C54.3048 22.875 54.2864 22.8474 54.2631 22.8242L51.6771 20.2382C51.6539 20.2149 51.6263 20.1964 51.5959 20.1838C51.5655 20.1712 51.533 20.1647 51.5001 20.1647C51.4672 20.1647 51.4346 20.1712 51.4043 20.1838C51.3739 20.1964 51.3463 20.2149 51.3231 20.2382L49.0611 22.5002L52.0001 25.4402Z",
    fill: "#728095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 53H78",
    stroke: "#728095"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 73H78",
    stroke: "#728095"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 93H78",
    stroke: "#728095"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 63H78",
    stroke: "#728095"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83H78",
    stroke: "#728095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingImg2);
export default __webpack_public_path__ + "static/media/onboarding-img2.96a2aad0eba4824b3a8045e29ba486ca.svg";
export { ForwardRef as ReactComponent };